import { Head } from "@inertiajs/react"
import { SonarLayout } from "@/components/sonar"
import { CashCollections, type CashCollectionsData } from "@/components/cash-collections"

interface CashCollectionsPageProps {
  data: CashCollectionsData
}

export default function CashCollectionsPage({ data }: CashCollectionsPageProps) {
  return (
    <>
      <Head title="Cash Collections">
        <meta
          name="description"
          content="Cash actually collected by disbursement month, compared window over window across DSD's reporting entities."
        />
        <meta property="og:title" content="Cash Collections" />
        <meta
          property="og:description"
          content="Cash actually collected by disbursement month, compared window over window across DSD's reporting entities."
        />
      </Head>
      <SonarLayout>
        <CashCollections data={data} />
      </SonarLayout>
    </>
  )
}
